import Swiper from 'swiper/bundle'
import { Autoplay } from 'swiper/modules'

export default class BrandList {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    this.swiper = new Swiper(this.el.querySelector('.swiper'), {
      modules: [Autoplay],
      loop: true,
      slidesPerView: 2,
      spaceBetween: 40,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 3000,
      breakpoints: {
        992: { 
          slidesPerView: 5,
         },
      }
    })
  }
}
